module.exports = __webpack_public_path__ + "static/media/fitness.16c6dc20.webp";